import { render, staticRenderFns } from "./ResearchMember.vue?vue&type=template&id=aa3fe4e6&"
import script from "./ResearchMember.vue?vue&type=script&lang=js&"
export * from "./ResearchMember.vue?vue&type=script&lang=js&"
import style0 from "./ResearchMember.vue?vue&type=style&index=0&id=aa3fe4e6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports